import Link from 'next/link';

import Button from '@mui/material/Button';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { CategoryProps } from '../utils/types';

const CategoryLink = ({
  href,
  onMouseEnter,
  showRightIcon,
  label,
  isActive = false,
  type = 'category',
}: CategoryProps) => (
  <Button
    component={Link}
    href={href || '#'}
    onMouseEnter={onMouseEnter}
    sx={{
      fontWeight: 500,
      lineHeight: '26px',
      letterSpacing: '0.46px',
      fontSize: '15px',
      color: 'rgba(0, 0, 0, 0.87)',
      padding: '0 11px',
      height: '42px',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      textTransform: 'none',
      ...(type === 'title' && {
        fontWeight: 'bold',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }),
      ...(type === 'category' && {
        '&:hover': {
          fontWeight: 'bold',
          textDecoration: 'underline',
          backgroundColor: 'rgba(116, 155, 141, 0.08)',
        },
      }),
      ...(isActive && {
        fontWeight: 'bold',
        textDecoration: 'underline',
        backgroundColor: 'rgba(116, 155, 141, 0.08)',
      }),
    }}
  >
    <span
      style={{
        WebkitLineClamp: 1 /* number of lines to show */,
        overflow: 'hidden',
        display: '-webkit-box',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
      }}
    >
      {label}
    </span>
    {showRightIcon && <ChevronRightIcon />}
  </Button>
);

export default CategoryLink;
